import { Injectable, inject } from '@angular/core';
import {
	Firestore,
	collection,
	doc,
	Timestamp,
	setDoc,
} from '@angular/fire/firestore';
import { LogType, Log } from '@interfaces/log.model';
import { UserModel } from '@interfaces/user.model';
import { AnalyticsService } from './analytics.service';
import { environment } from '@environments/environment';

@Injectable({
	providedIn: 'root',
})
export class LogService {
	private readonly firestore = inject(Firestore);
	private readonly analyticsService = inject(AnalyticsService);

	public async saveLog(
		user: UserModel,
		type: LogType,
		message: string,
		timestamp?: Timestamp,
		data?: Record<string, unknown>
	): Promise<void> {
		if (!user || !user?.id) return;

		const logsRef = collection(
			this.firestore,
			`companies/${environment.companyId}/users/${user.id}/logs`
		);
		const newLogRef = doc(logsRef);
		const logData: Log = {
			id: newLogRef.id,
			type,
			message,
			createdAt: timestamp ?? Timestamp.now(),
			data: data ?? {},
		};

		await setDoc(newLogRef, logData);

		console.log('Log saved, Type: ', logData.type, { logData });

		this.analyticsService.logEvent('log_saved', {
			path: `companies/${environment.companyId}/users/${user.id}/logs/${newLogRef.id}`,
			type,
			message,
			createdAt: timestamp ?? Timestamp.now(),
		});
	}
}
